import React from 'react';
import { Button } from 'react-bootstrap';
import varSass from '../../styles/abstracts/_variables.module.scss';

const variants = {
    secondary: 1,
    primary: 2,
    tertiary: 3,
    quaternary: 4
}

const MyCard = ({ img, title, desc, backTile, variant, centered, onButtonClick }) => {
    return (
        <div className={`my-card ${centered ? 'my-card--center' : null}`}>
            <div className={`my-card__side my-card__side--front ${centered ? 'my-card__side--center' : null}`}>
                <div className={`my-card__picture my-card__picture--${variants[variant]}`} style={{ backgroundImage: `linear-gradient(to right bottom, ${varSass[`color-${variant}-light`]}, ${varSass[`color-${variant}-dark`]}), url(${img})` }}>
                    &nbsp;
                </div>
                <h4 className="my-card__heading">
                    <span className={`my-card__heading-span my-card__heading-span--${variants[variant]}`}>{title}</span>
                </h4>
                <div className="my-card__details">
                    <span>{desc}</span>
                </div>

            </div>
            <div className={`my-card__side my-card__side--back ${centered ? 'my-card__side--center' : null} my-card__side--back-${variants[variant]}`}>
                <div className="my-card__cta">
                    <div className="my-card__price-box">
                        <p className="my-card__price-only">{backTile}</p>
                        {/* <p className="my-card__price-value">$497</p> */}
                    </div>
                    <Button className="button--ghost" variant="outline-light" size="lg" onClick={onButtonClick}>Register</Button>
                </div>
            </div>
        </div>
    )
}

export default MyCard;